export const getKeyStateTakeDetail = (userIid, nodeIid, item) =>
  `${userIid}-${nodeIid}-${item.iid}-take-detail`;

export const getKeyStateForRubricProgress = (userIid, nodeIid, item) =>
  `${userIid}-${nodeIid}-${item.iid}-rubric-progress`;
